import React from 'react';
import { Loader2, CheckCircle, Clock, Truck, XCircle, CreditCard, PackageCheck } from 'lucide-react';

export const LoadingSpinner = () => (
  <div className="p-12 text-center" data-testid="loading-spinner">
    <Loader2 className="h-8 w-8 animate-spin text-[#003B73] mx-auto" />
  </div>
);

export const EmptyState = ({ message }) => (
  <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center" data-testid="empty-state">
    <p className="text-gray-500">{message}</p>
  </div>
);

export const StatusBadge = ({ status }) => {
  const statusMap = {
    // Order statuses
    new: { label: 'Ny', class: 'bg-blue-50 text-blue-700 border-blue-200', icon: Clock },
    pending: { label: 'Vantande', class: 'bg-amber-50 text-amber-700 border-amber-200', icon: Clock },
    paid: { label: 'Betald', class: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CreditCard },
    confirmed: { label: 'Bekraftad', class: 'bg-blue-50 text-blue-700 border-blue-200', icon: CheckCircle },
    shipped: { label: 'Levererad', class: 'bg-indigo-50 text-indigo-700 border-indigo-200', icon: Truck },
    delivered: { label: 'Levererad', class: 'bg-indigo-50 text-indigo-700 border-indigo-200', icon: Truck },
    completed: { label: 'Avslutad', class: 'bg-gray-50 text-gray-700 border-gray-200', icon: PackageCheck },
    cancelled: { label: 'Avbruten', class: 'bg-red-50 text-red-600 border-red-200', icon: XCircle },
    // Store/general statuses
    approved: { label: 'Godkand', class: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CheckCircle },
    rejected: { label: 'Avvisad', class: 'bg-red-50 text-red-600 border-red-200', icon: XCircle },
    processed: { label: 'Behandlad', class: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CheckCircle },
  };
  const config = statusMap[status] || { label: status || 'Okand', class: 'bg-gray-50 text-gray-600 border-gray-200', icon: Clock };
  const IconComp = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold border ${config.class}`} data-testid={`status-badge-${status}`}>
      <IconComp className="h-3 w-3" />
      {config.label}
    </span>
  );
};
